<template>
  <div>
    <v-layout>
      <v-radio-group v-model="model" :rules="rules" row>
        <v-radio v-for="(option, optionIndex) in userTypeOptions"
                 :key="`user-type-option-${optionIndex}`"
                 :label="option.label"
                 :value="option.value"/>
      </v-radio-group>
    </v-layout>
    <v-layout>
      <v-expand-transition>
        <v-flex v-show="model === 'Demo'">
          <v-layout class="px-5">
            <v-checkbox class="mt-0" v-model="localOptions" label="Allow Debug Menu" value="AllowDebugMenu"></v-checkbox>
            <v-checkbox class="mt-0 pl-5" v-model="localOptions" label="Skip Tutorial" value="SkipTutorial"></v-checkbox>
          </v-layout>
        </v-flex>
      </v-expand-transition>
    </v-layout>
  </div>
</template>

<script>
import ModelBinding from '../../mixins/ModelBinding'
import { Rules } from '../../helpers'
import CurrentSession from '../../mixins/CurrentSession'

export default {
  name: 'AccountTypeField',
  mixins: [ ModelBinding, CurrentSession ],
  props: {
    /**
     * Additional options for demo accounts
     */
    options: Array,
    /**
     * User types
     */
    userTypeOptions: Array
  },
  data () {
    return {
      randomized: true,
      rules: Rules.account.type,
      localOptions: []
    }
  },
  // Automatically update the parent component
  watch: {
    localOptions (options) {
      var config = {}
      for (let option of options) {
        config[option] = true
      }
      this.$emit('update:config', config)
    },
    model (userType) {
      // If the account type is not Demo, clear the additional options
      if (userType !== 'Demo') {
        this.localOptions = []
      }
    },
    userTypeOptions: {
      handler () {
        setTimeout(() => {
          this.model = (this.userTypeOptions.length === 1)
            ? this.userTypeOptions[0].value
            : null
        }, 1)
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
